import styled from 'styled-components';
import { ControlButtons } from '../index.styled';

export const DialogBodyControlButtons = styled(ControlButtons)`
    gap: 1rem;
    padding: 1rem 0 0;
`;
